import { IRequestCommand } from 'app/services/authentication/connection/iRequestCommand';
import { ErrorDetails } from 'app/services/authentication/connection/interfaces/apiInterfaces';
import { CommandRequestType } from 'app/services/authentication/connection/commandRequestType';
import { ICommandResponse } from 'app/services/authentication/connection/iCommandResponse';
import { ICommandParameters } from 'app/services/authentication/connection/iCommandParameters';

export interface IGetTransportTypesPaginatedParameters extends ICommandParameters {
  carrierId: string;
  page?: number;
  size?: number;
  column?: string;
  sort?: string;
  find?: string;
}

export interface TransportTypePaginatedResponse {
  content: TransportTypeDTO[];
  totalPages: number;
  totalElements: number;
  size: number;
  number: number;
}

export interface TransportTypeDTO {
  id: number;
  name: string;
  visibleName: string | null;
  description: string;
  icon: string;
  maxPassengers: number;
  maxLuggage: number;
  orderIdx: number | null;
  total: number | null;
  clusterCode: string;
  onDemandPaxStr: string | null;
  programmedPaxStr: string | null;
  onDemandPax: boolean;
  programmedPax: boolean;
  imgList: { id?: number; imgUrl?: string; order?: number }[] | null;
  active: boolean;
}

export class GetTransportTypesPaginatedCommand extends IRequestCommand<
  TransportTypePaginatedResponse,
  ErrorDetails,
  IGetTransportTypesPaginatedParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'carriers/{carrierId}/transportTypes/paginated';

  public override setParameters(parameters: IGetTransportTypesPaginatedParameters) {
    this._commandUrl = this._commandUrl.replace('{carrierId}', parameters.carrierId);
    const params: string[] = [];
    if (parameters.page !== undefined) params.push(`page=${parameters.page}`);
    if (parameters.size !== undefined) params.push(`size=${parameters.size}`);
    if (parameters.column) params.push(`column=${parameters.column}`);
    if (parameters.sort) params.push(`sort=${parameters.sort}`);
    if (parameters.find) params.push(`find=${encodeURIComponent(parameters.find)}`);
    if (params.length > 0) {
      this._commandUrl += '?' + params.join('&');
    }
  }
}
